export default __webpack_public_path__ + "static/media/User_Inactive.d461de64.svg";